import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { productActions } from "../../../../../store/products-slice"
import InfoIcon from "../../../../InfoIcon"

const Resort = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredproducts = useSelector((state) => state.product.filteredProducts)
    let products=useSelector(state=>state.product.products)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(productActions.setFilteredItems(resort(filteredproducts??products, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(productActions.setFilteredItems(resort(filteredproducts??products, type, 'DESC')))
        }} />
    </Fragment>
}

export default Resort